module.exports = __webpack_public_path__ + "static/media/4.1.8d52b62b.png";